import React from "react";
import AttachmentMergesTable from "./AttachmentMergesTable.tsx";
import ContentBox from "../ContentBox/ContentBox";
import AttachmentMerge from "../../types/AttachmentMerge.ts";

type AttachmentMergesProps = {
  attachmentMerges: Array<AttachmentMerge>;
  headline: string;
};

export default function AttachmentMerges({ attachmentMerges, headline }: AttachmentMergesProps) {
  return (
    <ContentBox headline={headline}>
      <AttachmentMergesTable attachmentMerges={attachmentMerges} hasLink={true} />
    </ContentBox>
  );
}
